import React, {useEffect, useRef} from 'react';
import "./HelpOverview.css"
import {Layout} from "antd";
import {Content} from "antd/es/layout/layout";

function HelpRequestSupport(props) {
    useEffect(() => {

        // const script = document.createElement('script');
        // script.type = 'text/javascript';
        // // script.src = 'https://form.jotform.com/jsform/242264760161351';
        // script.src = "https://vieunite.com/242264760161351.js"
        // console.log("getting js")
        // console.log(script)
        // document.getElementById('jotform-container').appendChild(script);
        //
        // return () => {
        //     document.getElementById('jotform-container').removeChild(script);
        // };
    }, []);

    return (<div>
        <Layout>
            <Content style={{backgroundColor: '#F0F0F0', fontFamily: "Proxima Nova, sans-serif"}}>
                <div className="help-center-top-section">
                    <div className="help-center-text-content">
                        <h2 className={'help-center-subtitle'}>Vieunite Home
                            Support</h2>
                        <h3 className={'help-center-title'}>How Can We
                            Help?</h3>
                    </div>
                </div>

                <p style={{
                    width: '100%',
                    color: '#6A6A6A',
                    fontSize: '1rem',
                    fontWeight: '400',
                    paddingTop: '2rem',
                    paddingLeft: '8vw'
                }}>
                    <a href={'/home/support'} style={{cursor: 'pointer', color: '#6A6A6A'}}>Support</a> / Request Support
                </p>
                {/*<div id="jotform-container"></div>*/}
                <div style={{display: 'flex', flexDirection: 'row', overflow: 'hidden'}}>
                    <div className={'spacer'}></div>
                    <div style={{
                        backgroundColor: 'white',
                        width: '50%',
                        minWidth: '25rem',
                        borderRadius: '15px',
                        margin: '2rem 0 5rem 0',
                        // padding: '3rem 0',
                        overflow: 'hidden',
                    }}>
                        {/*<div style={{width: '100%', textAlign: 'center', fontSize: '2rem', fontWeight: 700}}>Vieunite*/}
                        {/*    Home Request Support*/}
                        {/*</div>*/}
                        <iframe
                            src="https://vieunite.com/Support_Request_for_Vieunite.html"
                            style={{width: '100%', border: 'none', display: 'inline-block', height: '111rem'}}
                            // title="HTML Viewer"
                        />
                        {/*<div id="jotform-container" style={{}}></div>*/}
                        {/*<div style={{width: '100%', height: '80px', backgroundColor: 'white', transform: 'translateY(-80px)'}}></div>*/}
                    </div>
                    <div className={'spacer'}></div>
                </div>
            </Content>
        </Layout>
    </div>)
}

export default HelpRequestSupport;